import apiClient from './apiClient';
import qs from 'qs';

export interface Subscriber {
  id?: number;
  idSub: number;
  title: string;
  email: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  address: string;
  zipCode: string;
  phoneNum: string;
  language: string;
  city: string;
  countryId: number;
  password: string;
}

export const subscriberService = {
  getAll: () => 
    apiClient.get('/v1/subscribers/search'),
 search: (params: {
    page?: number;
    size?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNum?: string;
    status?: string[];
  }) =>
    apiClient.get('/v1/subscribers/search', {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    }),

  getByAgency: (agencyId: number) =>
    apiClient.get(`/subscribers/agency/${agencyId}`),

  register: (subscriber: Subscriber) =>
    apiClient.post('/subscribers/register', subscriber),

  update: (id: number, subscriber: Subscriber) =>
    apiClient.put(`/subscribers/${id}`, subscriber),
  updateStatus: (id: number, status: String) =>
    apiClient.put(`/subscribers/status/${id}`, status), //todo,
  delete: (id: number) =>
    apiClient.delete(`/subscribers/${id}`),

  activate: (code: string, userId: string) =>
    apiClient.post(`/subscribers/activate?code=${code}&userId=${userId}`),

  getAllWithStatus: (status: string) =>
    apiClient.get(`/subscribers/status/${status}`)
};